import { TIllustrationProps } from '@/common/components/Illustrations/types';
import { Svg, G, Path, Defs, ClipPath, Rect } from 'react-native-svg';

export const LogoJCB = ({
  width = 53,
  height = 41,
  className,
}: TIllustrationProps) => {
  return (
    <Svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 53 41"
      fill="none"
    >
      <G clipPath="url(#clip0_5814_9401)">
        <Path
          d="M52.8234 32.5499C52.8234 37.0551 49.1549 40.7236 44.6497 40.7236H0.176758V8.35041C0.176758 3.8452 3.84529 0.176666 8.35051 0.176666H52.8234V32.5499Z"
          fill="white"
        />
        <Path
          d="M38.3423 24.2474H41.7212C41.8177 24.2474 42.043 24.2152 42.1395 24.2152C42.7831 24.0865 43.3302 23.5072 43.3302 22.7027C43.3302 21.9304 42.7831 21.3512 42.1395 21.1903C42.043 21.1581 41.8499 21.1581 41.7212 21.1581H38.3423V24.2474Z"
          fill="#28A032"
        />
        <Path
          d="M41.3348 2.91199C38.1168 2.91199 35.478 5.51858 35.478 8.76877V14.8508H43.7483C43.9414 14.8508 44.1666 14.8508 44.3275 14.883C46.194 14.9795 47.5777 15.9449 47.5777 17.6183C47.5777 18.9377 46.6445 20.064 44.9068 20.2892V20.3536C46.8054 20.4823 48.2535 21.5443 48.2535 23.1855C48.2535 24.9554 46.6445 26.1138 44.5206 26.1138H35.4458V38.0205H44.0379C47.2559 38.0205 49.8947 35.4139 49.8947 32.1637V2.91199H41.3348Z"
          fill="#28A032"
        />
        <Path
          d="M42.9119 18.0044C42.9119 17.2321 42.3648 16.7172 41.7212 16.6207C41.6568 16.6207 41.4959 16.5885 41.3994 16.5885H38.3423V19.4204H41.3994C41.4959 19.4204 41.689 19.4204 41.7212 19.3882C42.3648 19.2916 42.9119 18.7767 42.9119 18.0044Z"
          fill="#28A032"
        />
        <Path
          d="M8.9622 2.91199C5.74419 2.91199 3.10542 5.51858 3.10542 8.76877V23.2176C4.74661 24.0221 6.45215 24.537 8.1577 24.537C10.185 24.537 11.2792 23.3142 11.2792 21.6408V14.8186H16.2993V21.6086C16.2993 24.2474 14.6581 26.4035 9.09092 26.4035C5.71201 26.4035 3.07324 25.6633 3.07324 25.6633V37.9883H11.6653C14.8833 37.9883 17.5221 35.3817 17.5221 32.1315V2.91199H8.9622Z"
          fill="#00529E"
        />
        <Path
          d="M25.1483 2.91199C21.9303 2.91199 19.2915 5.51858 19.2915 8.76877V16.4276C20.7718 15.1726 23.3462 14.3681 27.4974 14.5612C29.7179 14.6577 32.0992 15.2691 32.0992 15.2691V17.747C30.9085 17.1356 29.4926 16.5885 27.6583 16.4598C24.5047 16.2346 22.6061 17.7792 22.6061 20.4823C22.6061 23.2176 24.5047 24.7623 27.6583 24.5048C29.4926 24.3761 30.9085 23.7969 32.0992 23.2176V25.6955C32.0992 25.6955 29.75 26.3069 27.4974 26.4035C23.3462 26.5965 20.7718 25.792 19.2915 24.537V38.0527H27.8836C31.1016 38.0527 33.7404 35.4461 33.7404 32.1959V2.91199H25.1483Z"
          fill="#C70C2F"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5814_9401">
          <Rect width="53" height="40.9003" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
